import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { State, getLanguage, getLegalEntity } from '@cemex/cmx-client-layout';
import { Store, select } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { getCurrentLanguageWithLocaleInfo } from '@ordersnproducts/utils/utils';
import { Features } from '@ordersnproducts/features';
import { CX_INPUT_DATE_FORMAT_TOKEN } from 'app/shared/cx-ui/cx-input-date/cx-input-date.config';
import { of } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, switchMap } from 'rxjs/operators';

export const cxDateFormatProvider = {
  provide: CX_INPUT_DATE_FORMAT_TOKEN,
  deps: [Store, FeatureToggleService, TranslateService],
  useFactory: (store: Store<State>, featureToggle: FeatureToggleService, ts: TranslateService) => {
    return of('M d, Y').pipe(
      switchMap((dateFormat) => {
        if (featureToggle.isFeatureEnabled(Features.DATE_FORMAT_BY_DEFAULT_UI)) {
          return store.pipe(
            select(getCurrentLanguageWithLocaleInfo),
            map((_) => {
              // TODO: Add new formatDate type definitions or make adapter to convert format to Flatpickr formatting
              // Date formats existing in current Default language definitions are defined in different code
              return dateFormat;
            }),
          );
        }

        return of(dateFormat);
      }),
      switchMap((dateFormat) => {
        if (featureToggle.isFeatureEnabled(Features.DATE_FORMAT_BY_LANG_UI)) {
          return store.pipe(
            select(getLanguage),
            switchMap((code) => ts.getTranslation(code)),
            map((lang) => {
              if (lang['global.cwcFormatDate'] === undefined) {
                console.warn(
                  '☸ Date format by Language is enabled, but missing translation key "global.cwcFormatDate"',
                );
                return dateFormat;
              }

              return lang['global.cwcFormatDate'];
            }),
          );
        }

        return of(dateFormat);
      }),
      switchMap((dateFormat) => {
        if (featureToggle.isFeatureEnabled(Features.DATE_FORMAT_BY_COUNTRY_UI)) {
          return store.pipe(
            select(getLegalEntity),
            filter((legalEntity) => !!legalEntity),
            map((legalEntity) => legalEntity.countryCode.trim()),
            map((country) => {
              switch (country) {
                case COUNTRY_CODE.UNITED_KINGDOM: {
                  return 'l, d M, Y';
                }

                default: {
                  return dateFormat;
                }
              }
            }),
          );
        }

        return of(dateFormat);
      }),
      distinctUntilChanged(),
      shareReplay(),
    );
  },
};
